<template>
  <div class="page-container md-layout-column">
    <md-app style="min-height: 100vh; height:100vh;" md-mode="fixed" v-if="fluff">
      <md-app-toolbar class="md-primary toolbarSize">
        <md-button class="md-icon-button" @click="menuVisible = true">
          <md-icon>menu</md-icon>
        </md-button>
        <span class="md-subheader">{{pageTitle}}</span>
        <div class="md-toolbar-section-end">
          <div class="md-layout-item md-size-5 offset-left-10">
              <md-menu md-size="small" md-align-trigger md-close-on-click>
                  <!-- md-button class="md-icon-button md-accent" md-menu-trigger>
                      <md-icon>more_vert</md-icon>
                  </md-button -->
                  <md-avatar class="md-small" md-menu-trigger alt="Avatar">
                    <md-icon v-if="getUser.photoURL === '' || getUser.photoURL === null">account_circle</md-icon>
                    <img v-else :src="getUser.photoURL">
                  </md-avatar>
                  <md-menu-content>
                      <md-menu-item class="md-accent" @click="displayProfile()">Profile</md-menu-item>
                      <md-menu-item class="md-accent" @click="logout()">Sign Out</md-menu-item>
                  </md-menu-content>
              </md-menu>
          </div>
          <span class="md-subheader">{{currentTime}}</span>
        </div>
      </md-app-toolbar>
      <md-app-drawer :md-active.sync="menuVisible">
        <div class="drawerSection">
          <md-list>
            <span class="padded">Loaded Season:</span>
            <md-list-item md-expand :md-expanded.sync="expandSeasons">
              <span>{{activeSeasonName}}</span>
              <md-list slot="md-expand">
                <md-subheader>Your Seasons</md-subheader>
                <md-list-item v-for="season in seasons" :key="season.id" class="md-inset" @click="selectSeason(season.id)">{{season.n}}</md-list-item>
                <md-list-item class="md-inset" @click="selectSeason(-2)">New...</md-list-item>
                <md-list-item class="md-inset" @click="selectSeason(-3)">Import..</md-list-item>
                <md-list-item md-expand :md-expanded.sync="expandSharedSeasons" v-if="shared.seasons.length > 0">
                  <md-subheader>Shared Seasons</md-subheader>
                  <md-list slot="md-expand">
                    <md-list-item v-for="season in shared.seasons" :key="season.id" class="md-inset" @click="selectSharedSeason(season.id)">{{season.owner}}: {{season.n}}</md-list-item>
                  </md-list>
                </md-list-item>
              </md-list>
            </md-list-item>
            <md-list-item to="/season/settings" v-if="(!shared.active && ![-1, -2, , -3].includes(activeSeasonId))" :class="{'drawerListItemDisabled': (activeSeasonId < 0 || shared.active)}" @click="menuVisible = false">
              <md-icon class="md-accent">settings</md-icon>
              <div class="md-list-item-text">
                <span>Settings</span>
              </div>
            </md-list-item>
            <md-list-item to="/season/stats" v-if="(![-1, -2, , -3].includes(activeSeasonId))" :class="{'drawerListItemDisabled': activeSeasonId < 0}" @click="menuVisible = false /* Season > Stats */">
              <md-icon class="md-accent">table_chart</md-icon>
              <div class="md-list-item-text">
                <span>Stats</span>
              </div>
            </md-list-item>
            <md-list-item to="/season/players" v-if="(!shared.active && ![-1, -2, , -3].includes(activeSeasonId))" :class="{'drawerListItemDisabled': (activeSeasonId < 0 || shared.active)}" @click="menuVisible = false /* Season > Players */">
              <md-icon class="md-accent">group</md-icon>
              <div class="md-list-item-text">
                <span>Players</span>
              </div>
            </md-list-item>
            <md-list-item to="/season/schedules" v-if="(!shared.active && ![-1, -2, , -3].includes(activeSeasonId))" :class="{'drawerListItemDisabled': (activeSeasonId < 0 || shared.active)}" @click="menuVisible = false /* Season > Schedules */">
              <md-icon class="md-accent">local_atm</md-icon>
              <div class="md-list-item-text">
                <span>Schedules</span>
              </div>
            </md-list-item>
            <md-list-item to="/season/games" v-if="(!shared.active && ![-1, -2, , -3].includes(activeSeasonId))" :class="{'drawerListItemDisabled': (activeSeasonId < 0 || shared.active)}" @click="menuVisible = false /* Season > Games */">
              <md-icon class="md-accent">casino</md-icon>
              <div class="md-list-item-text">
                <span>Games</span>
              </div>
            </md-list-item>
            <md-list-item md-expand :class="{'drawerListItemDisabled': activeSeasonId < 0}" v-if="gamesInProgress.length > 0" :md-expanded.sync="expandGames">
              <md-icon class="md-accent">schedule</md-icon>
              <div class="md-list-item-text">
                <span>Timers</span>
              </div>
              <md-list slot="md-expand">
                <md-list-item v-for="game in gamesInProgress" :key="game.id" class="md-inset" :class="{'drawerListItemDisabled': activeSeasonId < 0}" @click="selectGame(game.id)">
                  {{ game.d }}
                </md-list-item>
              </md-list>
            </md-list-item>
          </md-list>
        </div>
      </md-app-drawer>
      <md-app-content class="md-scrollbar">
        <md-snackbar md-position="center" :md-duration="statusDuration" md-persistent :md-active.sync="showStatusBar" class="md-accent" @md-closed="notifyComplete()">
          <span>{{statusMessage}}</span>
        </md-snackbar>
        <router-view></router-view>
      </md-app-content>
    </md-app>
    <md-dialog class="profileDialog" :md-active.sync="showProfileDialog" id="profileDialog" :md-close-on-esc="false" :md-click-outside-to-close="false" v-if="fluff">
      <md-dialog-title>Edit Profile</md-dialog-title>
      <md-dialog-content>
        <user-profile @cancel="displayProfileDialog = false" />
      </md-dialog-content>
    </md-dialog>
    <router-view v-if="!fluff"></router-view>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import { gameProgress } from './constants'
import UserProfile from './components/User-Profile'
const fb = require('./config.js')

export default {
  name: 'App',
  data: () => ({
    menuVisible: false,
    showStatusBar: false,
    statusDuration: 0,
    statusMessage: '',
    currentTime: '',
    expandSeasons: false,
    expandSharedSeasons: false,
    expandGames: false,
    displayProfileDialog: false
  }),
  components: {
    UserProfile
  },
  computed: {
    ...mapState(['loading', 'seasons', 'seasonGames', 'activeGameId', 'activeSeasonId', 'shared', 'currentUser']),
    ...mapGetters(['activeSeasonName', 'getUser', 'nextNotification']),
    gamesInProgress: function () {
      let games = []
      for (let i = 0; i < this.seasonGames.length; i++) {
        const game = this.seasonGames[i]
        if (game.p === gameProgress.created || game.p === gameProgress.in_progress) {
          games.push(game)
        }
      }
      return games
    },
    pageTitle: function () {
      if (this.$route.meta.hasOwnProperty('title')) {
        return this.$route.meta.title.replace('$season$', 'Season > ' + this.$store.getters.activeSeasonName).replace('$game$', 'Game > ' + this.$store.getters.activeGameName)
      } else {
        return 'Poker Season Manager'
      }
    },
    fluff: function () {
      if (this.$route.meta.hasOwnProperty('nofluff')) {
        return false
      } else {
        return true
      }
    },
    showProfileDialog: function () {
      return (this.displayProfileDialog || this.currentUser.new)
    }
  },
  beforeDestroy: function () {
    this.$store.dispatch('stopSnapshot', 'seasons')
    clearInterval(this.interval)
  },
  mounted: function () {
    this.time()
    this.interval = setInterval(this.time, 5000)
  },
  watch: {
    nextNotification: function () {
      if (this.nextNotification !== null && !this.showStatusBar) {
        this.statusMessage = this.nextNotification.message
        this.statusDuration = this.nextNotification.duration
        this.showStatusBar = true
        this.$store.commit('removeNotification')
      }
    }
  },
  methods: {
    time: function () {
      this.currentTime = DateTime.local().toFormat('HH:mm')
    },
    selectSeason: function (seasonId) {
      if (this.activeSeasonId !== seasonId) {
        this.$store.dispatch('clearActiveSeason')
        this.$store.dispatch('seasonActivate', { seasonId: seasonId }).then(() => {
          if (seasonId <= -2 || this.$route.path.toLowerCase().startsWith('/game')) {
            if (!this.$route.path.toLowerCase().startsWith('/season/settings')) {
              this.$router.push('/season/settings')
            }
            this.menuVisible = false
          }
          if (!this.$route.path.toLowerCase().startsWith('/home')) {
            this.menuVisible = false
          }
        })
        this.expandSeasons = false
      }
    },
    selectSharedSeason: function (seasonId) {
      if (this.activeSeasonId !== seasonId) {
        this.$store.dispatch('clearActiveSeason')
        this.$store.dispatch('seasonActivate', { seasonId: seasonId, shared: true }).then(() => {
          if (seasonId <= -2 || this.$route.path.toLowerCase().startsWith('/game')) {
            if (!this.$route.path.toLowerCase().startsWith('/season/settings')) {
              this.$router.push('/season/settings')
            }
            this.menuVisible = false
          }
          if (!this.$route.path.toLowerCase().startsWith('/home')) {
            this.menuVisible = false
          }
        })
        this.expandSharedSeasons = false
        this.expandSeasons = false
      }
    },
    selectGame: function (gameId) {
      if (this.activeGameId !== gameId) {
        this.$store.dispatch('gameActivate', gameId).then(() => {
          this.$router.push('/game/timer')
        })
      } else {
        this.$router.push('/game/timer')
      }
      this.menuVisible = false
    },
    logout: function () {
      this.menuVisible = false
      this.$store.dispatch('clearData')
      fb.auth.signOut().then(() => {
        this.$router.push('/login')
      }).catch(err => {
        console.log(err)
      })
    },
    seasonChanged: function (val) {
      if (this.activeSeasonId <= -2 || (this.activeSeasonId !== -1 && !this.$route.path.includes('/season'))) {
        if (!this.$route.path.toLowerCase().startsWith('/season/settings')) {
          this.$router.push('/season/settings')
        }
      }
      this.menuVisible = false
    },
    notifyComplete: function () {
      if (this.nextNotification !== null) {
        this.statusMessage = this.nextNotification.message
        this.statusDuration = this.nextNotification.duration
        this.showStatusBar = true
        this.$store.commit('removeNotification')
      }
    },
    displayProfile: function () {
      this.displayProfileDialog = true
    }
  }
}
</script>

<style lang="scss">
    @import "~vue-material/dist/theme/engine.scss";
    @include md-register-theme("default", (
    primary: md-get-palette-color(bluegrey, 300),
    accent: md-get-palette-color(orange, 500),
    theme: dark
    ));
    @include md-register-theme("Orange", (
    primary: md-get-palette-color(orange, 500),
    accent: md-get-palette-color(bluegrey, 300),
    theme: dark
    ));
    @import "~vue-material/dist/theme/all";

  .md-app {
    border: 1px solid;
  }
  .md-app-content {
    padding: 0px;
  }
  .md-drawer {
    width: 250px;
  }
  .md-app-content {
    padding: 0px !important;
  }
  .drawerSection {
    width: 100%;
    display: inline-block;
    vertical-align: top;
    overflow: auto;
    border: 1px solid rgba(#000, .12);
  }
  .padded {
    padding-left: 16px
  }
  .drawerListItemDisabled {
    pointer-events:none; //This makes it not clickable
    opacity:0.6;         //This grays it out to look disabled
  }
  .toolbarSize {
    max-height: 32px !important;
    min-height: 32px !important;
  }
  .PSMDrawerToolbar {
    min-height: 0px !important;
    height: 38px;
  }
  .profileDialog {
    width: 350px;
  }
  .profileDialog .md-dialog-content {
    padding: 0 0 0;
  }
 </style>
